"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIAbstractPageSection;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function UIAbstractPageSection(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return _react.default.createElement("section", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-template__section', className)
  }));
}

UIAbstractPageSection.propTypes = {
  children: _propTypes.default.node
};
UIAbstractPageSection.displayName = 'UIAbstractPageSection';
module.exports = exports.default;